import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { connect } from 'react-redux'
import './Footer.css'

const Footer = ({ unreadChatsCount }) => {
  const location = useLocation()

  return (
    <div className="appBottomMenu">
      {/* Chats Tab - Active by Default, Inactive When Other Tab is Selected */}
      <Link
        to="/dashboard"
        className={`item ${
          location.pathname === '/stories' || location.pathname === '/explore'
            ? 'inactive'
            : 'active'
        }`}
      >
        <div className="col d-flex justify-content-center align-items-center flex-column">
          <ion-icon
            name="chatbox-ellipses-outline"
            className={`fs-4 icon ${
              location.pathname === '/stories' ||
              location.pathname === '/explore'
                ? 'inactive'
                : 'active'
            }`}
          ></ion-icon>
          <strong
            className={
              location.pathname === '/stories' ||
              location.pathname === '/explore'
                ? 'inactive'
                : 'active'
            }
          >
            Chats
          </strong>
          {unreadChatsCount > 0 && (
            <span className="notification-badge">{unreadChatsCount}</span>
          )}
        </div>
      </Link>

      {/* Other Tabs - Dynamic Active State */}
      <Link
        to="/stories"
        className={`item ${
          location.pathname === '/stories' ? 'active' : 'inactive'
        }`}
      >
        <div className="col">
          <ion-icon
            name="megaphone-outline"
            className={`fs-4 icon ${
              location.pathname === '/stories' ? 'active' : 'inactive'
            }`}
          ></ion-icon>
          <strong
            className={location.pathname === '/stories' ? 'active' : 'inactive'}
          >
            Updates
          </strong>
        </div>
      </Link>

      <Link
        to="/explore"
        className={`item ${
          location.pathname === '/explore' ? 'active' : 'inactive'
        }`}
      >
        <div className="col">
          <ion-icon
            name="globe-outline"
            className={`icon ${
              location.pathname === '/explore' ? 'active' : 'inactive'
            }`}
          ></ion-icon>
          <strong
            className={location.pathname === '/explore' ? 'active' : 'inactive'}
          >
            Explore
          </strong>
        </div>
      </Link>
    </div>
  )
}

const mapStateToProps = ({ data }) => ({
  unreadChatsCount: data.unreadChatsCount // Pull from Redux
})

export default connect(mapStateToProps)(Footer)
